@if (validations.length > 0) {
  <div class="product-validation-list">
    <div class="validation-summary">
      <mat-icon [color]="invalidProductsCount === 0 ? 'primary' : 'warn'">
        {{ invalidProductsCount === 0 ? 'check_circle' : 'error' }}
      </mat-icon>
      <span class="summary-text">
        {{ invalidProductsCount === 0
        ? 'All ' + validations.length + ' products will generate valid filenames'
        : invalidProductsCount + ' of ' + validations.length + ' products have invalid filenames'
        }}
      </span>
      <button mat-stroked-button class="details-btn" (click)="openValidationDialog()">
        Review Filenames
      </button>
    </div>
  </div>
}
